import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import overrideProps from "@store/Framework/Common/Utilities/overrideProps";
import { NoInfer } from "@store/Framework/Types/Common";

export default <T>(baseProps: T, extendedProps: NoInfer<T> | undefined, overridedProps: NoInfer<T> | undefined): T => {
    return mergeProps(overrideProps(baseProps, overridedProps), extendedProps);
};
